<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('academy.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'college', params: { id: college.id } }">{{ $t('academy.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-4 text-center">
        <b-dropdown
          no-flip
          :text="Object.keys(college).length === 0 ? $t('academy.detail.cohort-selector.hint') : college.name"
        >
          <b-dropdown-item
            v-for="college in colleges"
            :to="{ name: 'college', params: { id: college.id } }"
          >{{ college.name }}</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-4">
        <b-img fluid thumbnail center style="height:50vh;" :src="poster.url"></b-img>
      </div>
      <div class="col-sm-8">
        <h4 class="text-sm-left text-center">{{ college.name }}</h4>
        <span class="text-sm-left text-center" v-html="college.founding"></span>
        <b-list-group>
          <b-list-group-item
            target="_blank"
            class="d-flex justify-content-between align-items-center"
            v-for="attachment in attachments"
            :href="attachment.url"
          >
            {{ attachment.name }}
            <b-icon icon="cloud-download" font-scale="2"></b-icon>
          </b-list-group-item>
        </b-list-group>
        <social-sharing-button-toolbar
          class="my-3"
          :title="social_sharing_title"
          :to="social_sharing_route"
        ></social-sharing-button-toolbar>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-card no-body>
          <b-tabs card pills justified>      
            <b-tab
              :title="$t('academy.detail.course-livestream.title')"
              v-if="Array.isArray(livestream_courses) && livestream_courses.length > 0"
            >
              <b-table
                :fields="livestream_courses_table_fields"
                :items="livestream_courses"
              >
                <template #cell(course)="data">
                  {{ days_of_week[data.item.week == 7 ? 0 : data.item.week] }}
                  {{ data.item.spk_start_time }} ~ {{ data.item.spk_end_time }}<br>
                  {{ data.item.title_full_name }}<br>
                  {{ data.item.lecturer.lecr_full_name }}
                </template>
                <template #cell(url)="data">
                  <b-button
                    variant="primary"
                    @click="showCourseLiveStreaming(data.item)"
                  >
                    {{ $t('academy.detail.course-livestream.button.livestream.label') }} <b-icon icon="play"></b-icon>
                  </b-button>
                </template>
              </b-table>
            </b-tab>
            <b-tab :title="$t('academy.detail.cource-series.title')">
              <b-dropdown no-flip :text="department ? department.name : $t('academy.detail.cource-series.department-selector.hint')">
                <b-dropdown-item
                  v-for="department in departments"
                  @click.native="selectDepartment(department.id)"
                >
                  {{ department.name }}
                </b-dropdown-item>
              </b-dropdown>
              <div v-if="department !== null">
                <b-table
                  :fields="on_demand_courses_table_fields"
                  :items="on_demand_courses"
                  v-if="Array.isArray(on_demand_courses) && on_demand_courses.length > 0"
                >
                  <template #cell(course)="data">
                    {{ data.item.title_full_name }}<br>
                    {{ data.item.lecturer.lecr_full_name }}<br>
                    {{ data.item.spkdate.slice(0, 10) }} ~ {{ data.item.enddate ? data.item.enddate.slice(0, 10) : '' }}
                  </template>
                  <template #cell(title_no)="data">
                    <b-button
                      variant="primary"
                      target="_blank"
                      :size="$i18n.locale === 'tw' ? '' : 'sm'"
                      :to="{ name: 'series', params: { series_no: data.value } }"
                      v-if="data.value !== null && data.value !== undefined && data.value !== ''"
                    >{{ $t('academy.detail.cource-series.button.stream-or-download.label') }}</b-button>
                  </template>
                </b-table>
              </div>
              <div v-else><br>{{ $t('academy.detail.cource-series.hint') }}</div>
            </b-tab>
            <b-tab :title="$t('academy.detail.admission-brochure.title')" active>
              <p>●<strong>{{ $t('academy.detail.admission-brochure.label.objective') }}</strong>：</p>
              <span v-html="college.objective"></span>
              <p>●<strong>{{ $t('academy.detail.admission-brochure.label.teaching-methods') }}</strong>：</p>
              <span v-html="college.teaching_methods"></span>
              <p>●<strong>{{ $t('academy.detail.admission-brochure.department-list.title') }}</strong>：{{ departmentCountSummary }}</p>
              <b-list-group>
                <b-list-group-item
                  class="d-flex justify-content-between align-items-center"
                  v-for="department in departments"
                >
                  <p>
                    {{ department.name }}<br>
                    {{ $t('academy.detail.admission-brochure.department-list.label.lecturer') }}：{{ department.lecturer.lecr_full_name }}<br>
                    {{ $t('academy.detail.admission-brochure.department-list.label.date') }}：{{ days_of_week[department.week == 7 ? 0 : department.week] }}<br>
                    {{ $t('academy.detail.admission-brochure.department-list.label.time') }}：{{ department.spk_start_time }} ~ {{ department.spk_end_time }}<br>
                    {{ $t('academy.detail.admission-brochure.department-list.label.livestream') }} {{ department.streaming == 'Y' ? '√' : 'X' }}
                    {{ $t('academy.detail.admission-brochure.department-list.label.audiovisual') }} {{ department.recording == 'Y' ? '√' : 'X' }}
                  </p>
                  <b-button
                    variant="info"
                    target="_blank"
                    :to="{ name: 'department', params: { id: department.id } }"
                  >
                    <p class="h3 text-white">{{ $t('academy.detail.admission-brochure.department-list.button.introduction') }}</p>
                    <b-icon icon="info-square" font-scale="2"></b-icon>
                  </b-button>
                </b-list-group-item>
              </b-list-group>
              <p>●<strong>{{ $t('academy.detail.admission-brochure.label.school-system') }}</strong>：</p>
              <span v-html="college.school_system"></span>
              <p>●<strong>{{ $t('academy.detail.admission-brochure.label.start-date') }}</strong>：{{ college.spkdate.slice(0, 10) }} ( {{ days_of_week[6] }} ) </p>
              <p>●<strong>{{ $t('academy.detail.admission-brochure.label.location') }}</strong>：</p>
              <span v-html="college.location"></span>
              <p>●<strong>{{ $t('academy.detail.admission-brochure.label.register-ways') }}</strong>：</p>
              <span v-html="college.register_ways"></span>
              <p>
                ●<strong>{{ $t('academy.detail.admission-brochure.label.register-fee') }}</strong>：
                {{ college.register_fee > 0 ? `NT$${college.register_fee}` : $t('academy.detail.admission-brochure.message.free') }}
              </p>
              <div class="text-center mt-4">
                <b-button
                  size="lg"
                  variant="primary"
                  :to="{ name: 'college-registration', params: { id: college.id } }"
                >
                  {{ $t('academy.detail.admission-brochure.button.register.label') }}
                </b-button>
              </div>
            </b-tab>
          </b-tabs>
        </b-card>
        <b-modal
          centered
          size="lg"
          id="course-live-streaming"
          :title="course ? course.title_full_name : ''"
        >
          <live-streaming-player :source="course_live_streaming_url"></live-streaming-player>
          <template #modal-footer="{ close }">
            <b-button class="w-100" variant="default" @click="close()">{{ $t('modal.button.close.label') }}</b-button>
          </template>
        </b-modal>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'

import axios from 'axios'
import VueAxios from 'vue-axios'

import { BreadcrumbPlugin } from 'bootstrap-vue'
import { ButtonPlugin } from 'bootstrap-vue'
import { CardPlugin } from 'bootstrap-vue'
import { DropdownPlugin } from 'bootstrap-vue'
import { IconsPlugin } from 'bootstrap-vue'
import { ImagePlugin } from 'bootstrap-vue'
import { ListGroupPlugin } from 'bootstrap-vue'
import { ModalPlugin } from 'bootstrap-vue'
import { TablePlugin } from 'bootstrap-vue'
import { TabsPlugin } from 'bootstrap-vue'

import SocialSharingButtonToolbar from '@/components/button-toolbars/SocialSharingButtonToolbar'
import LiveStreamingPlayer from '@/components/players/LiveStreamingPlayer'

import i18n from '@/plugins/i18n.js'

import CollegeApiService from '@/services/budaedu-api-services/college-api-service.js'
import CollegeDepartmentApiService from '@/services/budaedu-api-services/college-department-api-service.js'

Vue.use(axios)
Vue.use(BreadcrumbPlugin)
Vue.use(ButtonPlugin)
Vue.use(CardPlugin)
Vue.use(DropdownPlugin)
Vue.use(IconsPlugin)
Vue.use(ImagePlugin)
Vue.use(ListGroupPlugin)
Vue.use(ModalPlugin)
Vue.use(TablePlugin)
Vue.use(TabsPlugin)
Vue.use(VueAxios)

Vue.use(CollegeApiService)
Vue.use(CollegeDepartmentApiService)

export default {
  i18n,
  name: 'college',
  props: {
    id: Number
  },
  data() {
    return {
      colleges: [],
      college: null,
      poster: null,
      attachments: [],
      departments: [],
      livestream_courses: [],
      course: null,
      course_live_streaming_url: '',
      department: null,
      on_demand_courses: []
    }
  },
  computed: {
    social_sharing_title() {
      return `${this.$t('academy.title')} ${this.college.name}`;
    },
    social_sharing_route() {
      return { name: 'college', params: { id: this.college.id } }
    },
    days_of_week() {
      return [
        this.$t('days-of-week.sunday.full'),
        this.$t('days-of-week.monday.full'),
        this.$t('days-of-week.tuesday.full'),
        this.$t('days-of-week.wednesday.full'),
        this.$t('days-of-week.thursday.full'),
        this.$t('days-of-week.friday.full'),
        this.$t('days-of-week.saturday.full')
      ]
    },
    livestream_courses_table_fields() {
      return [
        { key: 'course', label: this.$t('academy.detail.course-livestream.table.header.course') },
        { key: 'url', label: this.$t('academy.detail.course-livestream.table.header.livestream') }
      ]
    },
    on_demand_courses_table_fields() {
      return [
        { key: 'course', label: this.$t('academy.detail.cource-series.table.header.course') },
        { key: 'title_no', label: this.$t('academy.detail.cource-series.table.header.series') }
      ]
    },
    departmentCountSummary() {
      const total_count = this.departments.length;
      const class_count = this.departments.filter(item => item && item.name === '學佛基礎進階班').length;
      const sect_count = total_count - class_count;
      return this.$t(
        'academy.detail.admission-brochure.department-list.description',
        { class_count, sect_count, total_count }
      );
    }
  },
  methods: {
    showCourseLiveStreaming(course) {
      this.course = course
      this.course_live_streaming_url = this.getLivestreamUrl(course.places)
      this.$bvModal.show('course-live-streaming')
    },
    getLivestreamUrl(places) {
      let livestream_place = places.filter(
        item => item.live_url !== ''
          && item.live_url !== null
          && item.live_url !== undefined
          && item.pivot.live == 'Y'
      ).shift();

      return livestream_place !== undefined ? livestream_place.live_url : '';
    },
    async selectDepartment(department_id) {
      const item = await this.$collegeDepartmentApiService.getById(department_id)

      let links = item.links
      const { data: { data } } = await axios({ 
        url: `${links.on_demand_courses.href}?include=lecturer&order=spkdate,asc`,
        methods: links.on_demand_courses.type
      })
      this.on_demand_courses = data

      this.department = item.data
    },
    async setCollege() {
      const college = this.id
        ? await this.$collegeApiService.getById(this.id, 'include=departments.lecturer')
        : await this.$collegeApiService.getLatestSession('include=departments.lecturer')

      this.college = college.data
      await this.setCollegeRelatedResources(college.links)
    },
    async setCollegeRelatedResources(resource_links) {
      await Promise.all([
        this.setPoster(resource_links.poster.href, resource_links.poster.type),
        this.setAttachments(resource_links.attachments.href, resource_links.attachments.type),
        this.setDepartments(resource_links.departments.href, resource_links.departments.type),
        this.setLivestreamCourses(resource_links.livestream_courses.href, resource_links.livestream_courses.type)
      ])
    },
    async setPoster(url, method) {
      const { data: { data } } = await axios({ url: url, method: method })
      this.poster = data
    },
    async setAttachments(url, method) { 
      const { data: { data } } = await axios({ url: `${url}?filter[uncategorized]`, method: method })
      this.attachments = data
    },
    async setDepartments(url, method) {
      const { data: { data } } = await axios({ url: `${url}?include=lecturer&order=week,asc|spk_start_time,asc|spk_end_time,asc|created_at,asc`, method });
      this.departments = data;
    },
    async setLivestreamCourses(url, method) {
      const { data: { data } } = await axios({
        url: `${url}?include=lecturer,places&order=week,asc|spk_start_time,asc|spk_end_time,asc`,
        method: method
      })
      this.livestream_courses = data
    },
    async setColleges() {
      const item = await this.$collegeApiService.query('order=spkdate,desc')
      this.colleges = item.data
    }
  },
  async created() {
    //alert(`Vue version : ${Vue.version}`)
    await this.setCollege()
    await this.setColleges()
  },
  components: {
    LiveStreamingPlayer,
    SocialSharingButtonToolbar
  },
  metaInfo() {
    const title = this.college
      ? `${this.$t('academy.title')}-${this.college.name}`
      : `${this.$t('academy.title')}`
    
    return {
      title: title,
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
}
</script>